import { fontSmoothing, getFontFamily } from '../../typography';
import idsTokensDefault from '../../utils/tokens/idsTokens';

const enabledStyles = (idsTokens = idsTokensDefault) => ({
  // Label
  '& .MuiFormLabel-root': {
    paddingBottom: idsTokens.textField.default.spacing.label.padding.bottom,

    /** values without a token */
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    fontSize: idsTokens.typography.font.size.sm,
    lineHeight: idsTokens.typography.lineHeight.sm,
    letterSpacing: idsTokens.typography.spacing.letter.md,
    fontFamily: getFontFamily(idsTokens),
    ...fontSmoothing,
    fontStyle: 'normal',
    fontWeight: idsTokens.typography.font.weight.regular,
    fontFeatureSettings: '"clig" off, "liga" off',

    /**
     * this will fail in react-testing-library because apparently
     * having a selector with a "+"" inside a ":has()" pseudo-class is not supported
     */
    // Label Text Area disabled
    '&:has(+ .MuiInputBase-root .MuiInputBase-inputMultiline[disabled])': {
      color: idsTokens.textField.default.color.label.disabled,
    },
  },

  // Input field
  '& .MuiInput-input': {
    gap: idsTokens.textField.default.spacing.standard.padding.gap,

    color: idsTokens.textField.default.color.input.enabled,
    border: `1px solid ${idsTokens.textField.default.color.border.enabled}`,
    borderRadius: idsTokens.textField.default.radius.standard,
    backgroundColor: idsTokens.textField.default.color.background.enabled,

    minWidth: idsTokens.textField.default.spacing.standard.min.width,
    minHeight: idsTokens.textField.default.spacing.standard.min.height,

    paddingTop: idsTokens.textField.default.spacing.standard.padding.top,
    paddingLeft: idsTokens.textField.default.spacing.standard.padding.left,

    paddingBottom: idsTokens.textField.default.spacing.standard.padding.bottom,

    /** values without a token */
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    lineHeight: idsTokens.typography.lineHeight.base,
    fontSize: idsTokens.typography.font.size.base,
    fontFamily: getFontFamily(idsTokens),
    ...fontSmoothing,
    fontStyle: 'normal',
    fontWeight: idsTokens.typography.font.weight.regular,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
  },
  // Input field placeholder
  '& .MuiInput-input::placeholder': {
    color: idsTokens.textField.default.color.placeholder,
  },
  // Input field placeholder (webkit)
  '& .MuiInput-input::-webkit-input-placeholder': {
    color: idsTokens.textField.default.color.placeholder,
  },
  // Input field placeholder (Firefox 19+)
  '& .MuiInput-input::-moz-placeholder': {
    color: idsTokens.textField.default.color.placeholder,
  },
  // Input field placeholder (Edge)
  '& .MuiInput-input::-ms-input-placeholder': {
    color: idsTokens.textField.default.color.placeholder,
  },
  // Input field multiline - Text Area
  '&.MuiInputBase-multiline > .MuiInputBase-input': {
    borderRadius: idsTokens.textField.default.radius.standard,
    border: `1px solid ${idsTokens.textField.default.color.border.enabled}`,
    backgroundColor: idsTokens.textField.default.color.background.enabled,
    borderColor: idsTokens.textField.default.color.border.enabled,
    minWidth: idsTokens.textArea.default.min.minWidth,
    minHeight: 'unset',
    paddingTop: idsTokens.textField.default.spacing.standard.padding.top,
    paddingRight: idsTokens.textField.default.spacing.standard.padding.right,
    paddingBottom: idsTokens.textField.default.spacing.standard.padding.bottom,
    paddingLeft: idsTokens.textField.default.spacing.standard.padding.left,
    gap: idsTokens.textField.default.spacing.standard.padding.gap,
  },
  // Input field with error
  '& .MuiInput-input[aria-invalid=true]': {
    gap: idsTokens.textField.error.spacing.standard.padding.gap,

    color: idsTokens.textField.error.color.input.enabled,
    border: `2px solid ${idsTokens.textField.error.color.border.enabled}`,
    borderRadius: idsTokens.textField.error.radius.standard,
    backgroundColor: idsTokens.textField.error.color.background.enabled,

    minWidth: idsTokens.textField.error.spacing.standard.min.width,
    minHeight: idsTokens.textField.error.spacing.standard.min.height,

    paddingTop: idsTokens.textField.error.spacing.standard.padding.top,
    paddingLeft: idsTokens.textField.error.spacing.standard.padding.left,

    paddingBottom: idsTokens.textField.error.spacing.standard.padding.bottom,

    // Input field multiline with error- Text Area
    '&.MuiInputBase-inputMultiline': {
      border: `2px solid ${idsTokens.textField.error.color.border.enabled}`,
    },
  },
  // Input field placeholder with error
  '& .MuiInput-input[aria-invalid=true]::placeholder': {
    color: idsTokens.textField.error.color.placeholder,
  },
  // Input field placeholder (webkit)
  '& .MuiInput-input[aria-invalid=true]::-webkit-input-placeholder': {
    color: idsTokens.textField.default.color.placeholder,
  },
  // Input field placeholder (Firefox 19+)
  '& .MuiInput-input[aria-invalid=true]::-moz-placeholder': {
    color: idsTokens.textField.default.color.placeholder,
  },
  // Input field placeholder (Edge)
  '& .MuiInput-input[aria-invalid=true]::-ms-input-placeholder': {
    color: idsTokens.textField.default.color.placeholder,
  },
  // Input field small
  '& .MuiInput-input.MuiInputBase-inputSizeSmall': {
    borderRadius: idsTokens.textField.default.radius.small,

    minWidth: idsTokens.textField.default.spacing.small.min.width,
    minHeight: idsTokens.textField.default.spacing.small.min.height,

    paddingTop: idsTokens.textField.default.spacing.small.padding.top,
    paddingLeft: idsTokens.textField.default.spacing.small.padding.left,

    paddingBottom: idsTokens.textField.default.spacing.small.padding.bottom,

    /** values without a token */
    fontSize: idsTokens.typography.font.size.sm,
    letterSpacing: idsTokens.typography.spacing.letter.md,

    '&.MuiInputBase-inputMultiline': {
      minWidth: idsTokens.textArea.default.min.minWidth,
      minHeight: 'unset',
      paddingTop: idsTokens.textField.default.spacing.small.padding.top,
      paddingRight: idsTokens.textField.default.spacing.small.padding.right,
      paddingBottom: idsTokens.textField.default.spacing.small.padding.bottom,
      paddingLeft: idsTokens.textField.default.spacing.small.padding.left,
      gap: idsTokens.textField.default.spacing.small.padding.gap,
    },

    /** values without a token */
    lineHeight: idsTokens.typography.lineHeight.sm,
    fontFamily: getFontFamily(idsTokens),
    ...fontSmoothing,
    fontStyle: 'normal',
    fontWeight: idsTokens.typography.font.weight.regular,
    fontFeatureSettings: '"clig" off, "liga" off',

    // Helper text Text Area disabled
    '&.Mui-disabled': {
      color: idsTokens.textField.default.color.help.disabled,
    },
  },
  // Helper text
  '& .MuiFormHelperText-root': {
    color: idsTokens.textField.default.color.help.enabled,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 4,
  },

  '&  .MuiFormHelperText-root': {
    color: idsTokens.textField.default.color.help.enabled,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 4,
    '& span': {
      color: 'currentColor',
      marginLeft: 'auto',
    },
  },
  // Helper Text with error
  '& .MuiFormHelperText-root.Mui-error': {
    color: idsTokens.textField.error.color.help.enabled,
  },
});

const hoverStyles = (idsTokens = idsTokensDefault) => ({
  // Label
  '&:hover .MuiFormLabel-root': {
    color: idsTokens.textField.default.color.label.hover,
  },
  // Input field
  '&:hover .MuiInput-input': {
    outline: 'none',
    border: `1px solid ${idsTokens.textField.default.color.border.hover}`,
    backgroundColor: idsTokens.textField.default.color.background.hover,
    color: idsTokens.textField.default.color.input.hover,
  },

  // Input field with error
  '&:hover .MuiInput-input[aria-invalid=true]': {
    outline: 'none',
    border: `2px solid ${idsTokens.textField.error.color.border.hover}`,
    backgroundColor: idsTokens.textField.error.color.background.hover,
    color: idsTokens.textField.error.color.input.hover,

    '&.MuiInputBase-inputMultiline': {
      border: `2px solid ${idsTokens.textField.error.color.border.hover}`,
      backgroundColor: idsTokens.textField.error.color.background.hover,
    },
  },

  // Multiline Text Area
  '&:hover .MuiInputBase-inputMultiline': {
    backgroundColor: idsTokens.textField.default.color.background.hover,
    borderColor: idsTokens.textField.default.color.border.hover,
  },

  // Helper text
  '&:hover .MuiFormHelperText-root': {
    color: idsTokens.textField.default.color.help.hover,
  },
  // Helper Text with error
  '&:hover .MuiFormHelperText-root.Mui-error': {
    color: idsTokens.textField.error.color.help.hover,
  },
});

const focusedStyles = (idsTokens = idsTokensDefault) => ({
  // Label
  '&:focus-within .MuiFormLabel-root': {
    color: idsTokens.textField.default.color.label.focus,
  },

  // Input field focused
  '&:focus-within .MuiInput-input:focus': {
    outline: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
    outlineOffset: 2,
    backgroundColor: idsTokens.textField.default.color.background.focus,
    border: `1px solid ${idsTokens.textField.default.color.border.focus}`,
    color: idsTokens.textField.default.color.input.focus,
    '&:hover': {
      borderColor: idsTokens.textField.default.color.border.hover,
    },
  },
  // Input field with error, focused
  '&:focus-within .MuiInput-input[aria-invalid=true]': {
    border: `2px solid ${idsTokens.textField.error.color.border.pressed}`,
    backgroundColor: idsTokens.textField.error.color.background.focus,
    outline: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
    outlineOffset: 2,
    color: idsTokens.textField.error.color.input.focus,
    '&:hover': {
      borderColor: idsTokens.textField.error.color.border.hover,
    },
  },
  // Helper text
  '&:focus-within .MuiFormHelperText-root': {
    color: idsTokens.textField.default.color.help.focus,
  },
  // Helper Text with error
  '&:focus-within .MuiFormHelperText-root.Mui-error': {
    color: idsTokens.textField.error.color.help.focus,
  },
});

const pressedStyles = (idsTokens = idsTokensDefault) => ({
  // Label
  '&:has(:active) .MuiFormLabel-root': {
    color: idsTokens.textField.default.color.label.pressed,
  },

  // Input field
  '& .MuiInput-input:focus:active': {
    outline: 'none',
    color: idsTokens.textField.default.color.input.pressed,
    border: `1px solid ${idsTokens.textField.default.color.border.pressed}`,
    backgroundColor: idsTokens.textField.default.color.background.pressed,
  },
  // Input field with error
  '& .MuiInput-input[aria-invalid=true]:active:hover': {
    outline: 'none',
    color: idsTokens.textField.error.color.input.pressed,
    border: `2px solid ${idsTokens.textField.error.color.border.pressed}`,
    backgroundColor: idsTokens.textField.error.color.background.pressed,
  },

  // Helper text
  '&:has(:active) .MuiFormHelperText-root': {
    color: idsTokens.textField.default.color.help.pressed,
  },
  // Helper Text with error
  '&:has(:active) .MuiFormHelperText-root.Mui-error': {
    color: idsTokens.textField.error.color.help.pressed,
  },
});

const disabledStyles = (idsTokens = idsTokensDefault) => ({
  // Label
  '& .MuiFormLabel-root.Mui-disabled': {
    color: idsTokens.textField.default.color.label.disabled,
  },
  '& .MuiInput-input[disabled]': {
    color: idsTokens.textField.default.color.input.disabled,
    pointerEvents: 'none',
    border: `1px solid ${idsTokens.textField.default.color.border.disabled}`,
    background: idsTokens.textField.default.color.background.disabled,

    '&.MuiInputBase-inputMultiline.Mui-disabled': {
      border: `1px solid ${idsTokens.textField.default.color.border.disabled}`,
      background: idsTokens.textField.default.color.background.disabled,
    },
  },
  '& .MuiFormHelperText-root.Mui-disabled': {
    color: idsTokens.textField.default.color.help.disabled,
  },
});

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    ...enabledStyles(idsTokens),
    ...hoverStyles(idsTokens),
    ...focusedStyles(idsTokens),
    ...pressedStyles(idsTokens),
    ...disabledStyles(idsTokens),
  },
});
